<template>
  <div v-show="$i18n.locale==='zh'">
    <div v-if="cur_width" id="box-right" :class="{ 'img-close': is_close}">
      <el-image v-if="this.status === 'open'"  :src="src_close" class="close-icon" @click="changeStatus"></el-image>
      <el-image v-else :src="src_open" class="close-icon" @click="changeStatus"></el-image>
      <el-image  :src="src_weixin" style="width: 10vw"></el-image>
    </div>
  </div>

</template>


<script>
export default {
  data() {
    return {
      src_close: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/close.jpg',
      src_open: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/open.jpg',
      src_weixin: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/weixin.jpg',
      status:'close',
      is_close: true,
    };
  },
  methods: {
    changeStatus() {
        this.status = this.status === 'open' ? 'close' : 'open';
        this.is_close = this.is_close === false ? true : false;
    }
  },
  computed: {
    //移动端隐藏扫码
    cur_width() {
      return document.documentElement.clientWidth > 992;
    },
  },
};
</script>

<style lang="less" scoped>
#box-right {
    position: fixed;
    right: 0px;
    top: 40%;
    width:12.5vw;
    transition: right 0.5s;
    z-index: 1000;
}
.close-icon{
    width: 2vw;
    vertical-align: top;
    cursor: pointer;
}
.img-close {
    right:-10vw !important;
}
@media screen and (max-width: 992px) {
    #box-right {
      display: none;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Weixin.vue